// ============================================================
// ChatChips (v8.363.4) - the conversations, as chips: Vox — all, the
// groups, Players, and one per private vox with an unread count and a
// close. The active chip is where the composer aims.
// ============================================================
import type { Conversation, ConversationKey, Unread } from '../engine/chat';
import clsx from '../utils/clsx';
import styles from '../styles/CombatLogPanel.module.css';

interface Props {
  conversations: Conversation[];
  active: ConversationKey;
  unread: Unread;
  onSelect: (key: ConversationKey) => void;
  onClose: (uid: string) => void;
}

export default function ChatChips({ conversations, active, unread, onSelect, onClose }: Props) {
  return (
    <div className={styles.chatChips} role="tablist" aria-label="Vox conversations" data-testid="chat-chips">
      {conversations.map((c) => {
        const n = unread.byConv[c.key] ?? 0;
        return (
          <span key={c.key} className={clsx(styles.chatChip, c.key === active && styles.chatChipActive)}>
            <button
              type="button"
              role="tab"
              aria-selected={c.key === active}
              className={styles.chatChipBtn}
              data-testid={`chat-chip-${c.key}`}
              onClick={() => onSelect(c.key)}
              title={c.label}
            >
              {c.label}
              {n > 0 && (
                <span className={styles.chatChipUnread} data-testid="chat-chip-unread">
                  {n}
                </span>
              )}
            </button>
            {c.closable && (
              <button
                type="button"
                className={styles.chatChipClose}
                aria-label={`Close ${c.label}`}
                onClick={() => onClose(c.key.slice(3))}
              >
                ✕
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
}
